import { fetchInitialState, login } from "@/components/access/ducks/Actions"
import {
  CONNECT_USER,
  CREATE_CUSTOMER,
  CREATE_CUSTOMER_AVATAR,
  FETCH_TICKET,
  receiveCreateCustomerSuccess,
  receiveTicket,
  VALIDATE_SUBDOMAIN,
} from "@/components/customer/ducks/Actions"
import {
  apiConnectUser,
  apiCreateCustomer,
  apiCreateCustomerAvatar,
  apiFetchTicket,
  apiValidateSubdomain,
} from "@/components/customer/ducks/AJAX"

export default (store) => (next) => (action) => {
  const { dispatch } = store
  const fetchTicketSuccess = (response) => {
    dispatch(receiveTicket(response.ticket))
  }
  const createCustomerSuccess = (cb) => (resp) => {
    dispatch(receiveCreateCustomerSuccess())
    if (cb) {
      cb(resp)
    }
    window.location.reload()
  }
  const connectUserSuccess = (response) => {
    dispatch(receiveTicket(response.ticket))
    dispatch(login())
    dispatch(fetchInitialState())
  }

  switch (action.type) {
    case VALIDATE_SUBDOMAIN:
      apiValidateSubdomain(action.subdomain, action.success, action.error)
      return next(action)

    case CREATE_CUSTOMER_AVATAR:
      apiCreateCustomerAvatar(action.params, action.success, action.error)
      return next(action)

    case CREATE_CUSTOMER:
      apiCreateCustomer(action.params, createCustomerSuccess(action.success), action.error)
      return next(action)

    case CONNECT_USER:
      apiConnectUser(action.ticketId, action.params, connectUserSuccess, action.error)
      return next(action)

    case FETCH_TICKET:
      apiFetchTicket(action.ticketId, fetchTicketSuccess, action.error)
      return next(action)

    default:
      return next(action)
  }
}
